import industriesMap from '../../profile_suggests/industries.json';
import occupationsMap from '../../profile_suggests/occupations.json';
import { SENIORITY_LEVELS } from '@/constants/seniority';

type TTaxonomyMap = Record<string, { code: string; title: string }>;

export const OCCUPATIONS_MAP = occupationsMap as TTaxonomyMap;
export const INDUSTRIES_MAP = industriesMap as TTaxonomyMap;
export const SENIORITY_MAP = SENIORITY_LEVELS.reduce<TTaxonomyMap>((acc, level) => {
  acc[level.code] = level;
  return acc;
}, {});

export const parseCodesParam = (value?: string | string[]): string[] => {
  const raw = Array.isArray(value) ? value.join(',') : (value ?? '');

  return [
    ...new Set(
      raw
        .split(',')
        .map((code) => code.trim())
        .filter(Boolean),
    ),
  ];
};

export const getOccupationTitle = (code?: string | null) =>
  code ? (OCCUPATIONS_MAP[code]?.title ?? '') : '';

export const getIndustryTitle = (code?: string | null) =>
  code ? (INDUSTRIES_MAP[code]?.title.replace(/\s*\(except [^)]*\)/gi, '') ?? '') : '';

export const getSeniorityTitle = (code?: string | null) =>
  code ? (SENIORITY_MAP[code.toUpperCase()]?.title ?? '') : '';
